import './logoSlider.scss';

(() => {
    const sliders = document.querySelectorAll('.logo-slider');
    if (!sliders.length) return;

    const MAX_REPEATS = 12;

    function makeClone(node) {
        const clone = node.cloneNode(true);
        clone.dataset.clone = 'true';
        clone.setAttribute('aria-hidden', 'true');

        clone
            .querySelectorAll('a, button, input, textarea, select, [tabindex]')
            .forEach((el) => el.setAttribute('tabindex', '-1'));

        return clone;
    }

    function rebuildSlider(slider) {
        const track = slider.querySelector('.logo-slider__track');
        if (!track) return;

        const isNormal = slider.classList.contains('direction-normal');
        const originals = [...track.children].filter(
            (el) => el.dataset.clone !== 'true'
        );

        if (!originals.length) return;

        // Reset auf Originale
        track.replaceChildren(...originals);

        let scrollDistance = 0;

        if (isNormal) {
            // Links -> Rechts:
            // ein Clone-Set vor die Originale setzen
            const leadingCloneSet = originals.map(makeClone);
            track.prepend(...leadingCloneSet);

            const firstLeadingClone = leadingCloneSet[0];
            const firstOriginal = originals[0];

            scrollDistance = firstOriginal.offsetLeft - firstLeadingClone.offsetLeft;

            if (!scrollDistance || scrollDistance < 1) return;

            track.style.setProperty('--scroll-distance', `${scrollDistance}px`);

            // rechts weiter auffüllen
            const minTrackWidth = slider.clientWidth + scrollDistance;
            let repeats = 2; // leading clones + originals

            while (track.scrollWidth < minTrackWidth && repeats < MAX_REPEATS) {
                originals.forEach((node) => {
                    track.appendChild(makeClone(node));
                });
                repeats++;
            }
        } else {
            // Default + direction-reverse:
            // Rechts -> Links:
            // ein Clone-Set hinter die Originale setzen
            const trailingCloneSet = originals.map(makeClone);
            track.append(...trailingCloneSet);

            const firstOriginal = originals[0];
            const firstClone = trailingCloneSet[0];

            scrollDistance = firstClone.offsetLeft - firstOriginal.offsetLeft;

            if (!scrollDistance || scrollDistance < 1) return;

            track.style.setProperty('--scroll-distance', `${scrollDistance}px`);

            const minTrackWidth = slider.clientWidth + scrollDistance;
            let repeats = 2; // originals + first clone set

            while (track.scrollWidth < minTrackWidth && repeats < MAX_REPEATS) {
                originals.forEach((node) => {
                    track.appendChild(makeClone(node));
                });
                repeats++;
            }
        }
    }

    function scheduleSlider(slider) {
        requestAnimationFrame(() => rebuildSlider(slider));
    }

    sliders.forEach((slider) => {
        const track = slider.querySelector('.logo-slider__track');
        if (!track) return;

        scheduleSlider(slider);

        window.addEventListener('load', () => scheduleSlider(slider));

        track.querySelectorAll('img').forEach((img) => {
            if (!img.complete) {
                img.addEventListener('load', () => scheduleSlider(slider), {
                    once: true
                });
            }
        });

        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => scheduleSlider(slider), 150);
        });
    });
})();